import { InteractiveTable, useInteractiveTableContext } from '@dreryk/react-components';

import { DiagnosisTableBean } from '../../DiagnosesFormTab.types';
import { VisitDiagnosisRemoveEventInterceptor } from '../interceptors/VisitDiagnosisRemoveEventInterceptor';

type RemoveCellProps = {
   readonly visitId: number;
   readonly index: number;
};

export const RemoveCell = (props: RemoveCellProps): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<DiagnosisTableBean>();

   const code = getCellValue('code', props.index);

   return (
      <VisitDiagnosisRemoveEventInterceptor visitId={props.visitId} code={code}>
         <InteractiveTable.DeleteRowCell index={props.index} />
      </VisitDiagnosisRemoveEventInterceptor>
   );
};
